import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  Card,
  ButtonGroup,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

import DashboardContext from "../../../context/dashboard/DashboardContext";

const PaypalPayments = () => {
  const dashboardContext = useContext(DashboardContext);
  const { getDashboardPayments, payments } = dashboardContext;
  const [loading, setLoading] = useState(false);
  const [daySelected, setDaySelected] = useState("Today");
  const [dayButtonColor, setDayButtonColor] = useState({
    todayBG: "#ffffff",
    todayText: "normal",
    yesterdayBG: "#ffffff",
    yesterdayText: "normal",
  });
  const [totalRecords, setTotalRecords] = useState({
    unmatched: 0,
    matched: 0,
    total: 0,
  });

  useEffect(() => {
    if (daySelected) {
      if (daySelected === "Today") {
        setDayButtonColor({
          todayBG: "#dddddd",
          todayText: "bold",
          yesterdayBG: "#ffffff",
          yesterdayText: "normal",
        });
      } else if (daySelected === "Yesterday") {
        setDayButtonColor({
          todayBG: "#ffffff",
          todayText: "normal",
          yesterdayBG: "#dddddd",
          yesterdayText: "bold",
        });
      }
    }
  }, [daySelected]);

  const useStyles = makeStyles((theme) => ({
    card: {
      minHeight: 30,
      padding: theme.spacing(1),
    },
    bgColor: {
      backgroundColor: theme.palette.primary.dark,
    },
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    var from = "";
    var to = "";
    setLoading(true);
    if (daySelected === "Today") {
      from = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(24, 0, 0, 0)).toISOString();
    } else if (daySelected === "Yesterday") {
      from = new Date(new Date().setHours(-24, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
    }
    getDashboardPayments(from, to);
    //eslint-disable-next-line
  }, [daySelected]);

  useEffect(() => {
    if (payments) {
      var total_unmatched =
        payments.paypal_express.unmatched +
        payments.paypal_billing.unmatched +
        payments.visa.unmatched +
        payments.master.unmatched;
      var total_matched =
        payments.paypal_express.matched +
        payments.paypal_billing.matched +
        payments.visa.matched +
        payments.master.matched;
      var total_records = total_unmatched + total_matched;
      setTotalRecords({
        unmatched: total_unmatched,
        matched: total_matched,
        total: total_records,
      });
      setLoading(false);
    }
  }, [payments]);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        className={classes.bgColor}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          style={{
            height: 100,
          }}
        >
          <Grid item>
            <Typography variant="h6" className={classes.headerText}>
              Payments{" "}
            </Typography>{" "}
          </Grid>{" "}
          <Grid item>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                height: "90%",
              }}
              spacing={1}
            >
              <Grid item>
                <Typography variant="h6" className={classes.headerText}>
                  <strong> {totalRecords.total} </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid item>
                <Typography variant="h6" className={classes.headerText}>
                  payments{" "}
                </Typography>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            {" "}
            {payments && loading === false ? (
              <Card className={classes.card}>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  spacing={1}
                  style={{
                    height: "100%",
                  }}
                >
                  <Grid item>
                    <Typography variant="subtitle2">
                      PAYPAL_EXPRESS:{" "}
                      <strong>
                        {" "}
                        {payments.paypal_express.unmatched +
                          payments.paypal_express.matched}{" "}
                      </strong>{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                  <Grid item> </Grid>{" "}
                  <Grid item>
                    <Typography variant="subtitle2">
                      BILLING_AGREEMENT:{" "}
                      <strong>
                        {" "}
                        {payments.paypal_billing.unmatched +
                          payments.paypal_billing.matched}{" "}
                      </strong>{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                  <Grid item> </Grid>{" "}
                  <Grid item>
                    <Typography variant="subtitle2">
                      VISA:{" "}
                      <strong>
                        {" "}
                        {payments.visa.unmatched + payments.visa.matched}{" "}
                      </strong>{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                  <Grid item> </Grid>{" "}
                  <Grid item>
                    <Typography variant="subtitle2">
                      MASTER:{" "}
                      <strong>
                        {" "}
                        {payments.master.unmatched +
                          payments.master.matched}{" "}
                      </strong>{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Card>
            ) : (
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                style={{
                  height: "80%",
                }}
              >
                <Grid item>
                  <CircularProgress
                    style={{
                      color: "#ffffff",
                    }}
                  />{" "}
                </Grid>{" "}
              </Grid>
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </AccordionSummary>{" "}
      <AccordionDetails>
        {" "}
        {payments && loading === false ? (
          <Grid
            container
            direction="row"
            style={{
              height: 250,
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                height: "100%",
              }}
            >
              <Grid
                container
                direction="row"
                style={{
                  height: "100%",
                }}
                alignItems="stretch"
              >
                <Grid
                  item
                  style={{
                    width: "40%",
                  }}
                >
                  <Typography variant="body2">
                    <strong> Type </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> Unmatched </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> Matched </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> Total </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={12}>
                  <Divider variant="fullWidth" />
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "40%",
                  }}
                >
                  <Typography variant="body2"> PAYPAL_EXPRESS </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.paypal_express.unmatched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.paypal_express.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.paypal_express.unmatched +
                      payments.paypal_express.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "40%",
                  }}
                >
                  <Typography variant="body2">
                    PAYPAL_BILLING_AGREEMENT{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.paypal_billing.unmatched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.paypal_billing.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.paypal_billing.unmatched +
                      payments.paypal_billing.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "40%",
                  }}
                >
                  <Typography variant="body2"> VISA </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.visa.unmatched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.visa.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.visa.unmatched + payments.visa.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "40%",
                  }}
                >
                  <Typography variant="body2"> MASTER </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.master.unmatched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.master.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.master.unmatched + payments.master.matched}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={12}>
                  <Divider variant="fullWidth" />
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "40%",
                  }}
                >
                  <Typography variant="body2">
                    <strong> Total Records </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> {totalRecords.unmatched} </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> {totalRecords.matched} </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "20%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> {totalRecords.total} </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={12}>
                  <Divider variant="fullWidth" />
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "50%",
                  }}
                >
                  <Typography variant="body2"> Total Gross </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "50%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {payments.total_gross.toLocaleString("en", {
                      minimumFractionDigits: 2,
                    })}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "50%",
                  }}
                >
                  <Typography variant="body2"> Total Merchant Fee </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "50%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    {" "}
                    {"-" +
                      payments.total_fee.toLocaleString("en", {
                        minimumFractionDigits: 2,
                      })}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "50%",
                  }}
                >
                  <Typography variant="body2">
                    <strong> Total Net </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "50%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong>
                      {" "}
                      {payments.total_net.toLocaleString("en", {
                        minimumFractionDigits: 2,
                      })}{" "}
                    </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>
        ) : (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{
              height: "80%",
            }}
          >
            <Grid item>
              <CircularProgress />
            </Grid>{" "}
          </Grid>
        )}{" "}
      </AccordionDetails>{" "}
    </Accordion>
  );
};

export default PaypalPayments;
